import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/cemex';

export const getCemexTrackingOrders = async ({
  filters: { date, project },
}) => {
  return axios
    .get(endPoint.concat(`/${project}/orders?date=${date}`))
    .then((response) => response)
    .catch((error) => error.response);
};

export const getCemexTracking = async ({ filters: { date, project } }) => {
  return axios
    .get(endPoint.concat(`/${project}/tracking?date=${date}`))
    .then((response) => response)
    .catch((error) => error.response);
};
